<div class="updatePasswordPage">
  @if (isTokenValid || isTokenInvalid) {
  <form class="updatePassowrdForm" (ngSubmit)="onSubmit()">
    <div style="text-align: center">
      <img class="logo" src="assets/images/frankly.png" alt="CatchHub" />
    </div>
    @if (isTokenValid) {
    <div style="font-size: 14px; text-align: center; font-weight: bold; padding-top: 12px">
      @if (!isActivateAccount) {
      <p style="text-align: center">Reset your Password</p>
      } @if (isActivateAccount) {
      <h3 style="text-align: center">Set password and activate your trial account</h3>
      }
    </div>
    } @if (isTokenInvalid) {
    <div style="width: 367px">
      @if (!isActivateAccount) {
      <div style="text-align: center; color: #c1272c; font-size: 14px; font-weight: bold; padding: 20px">Link is invalid or expired, please contact your admin!</div>
      } @if (isActivateAccount) {
      <div style="text-align: center; color: #c1272c; font-size: 14px; font-weight: bold; padding: 20px">Link is invalid or expired, please contact catch support!</div>
      }
      <!-- <div style="text-align: center; font-size: 14px;" >
          Forgotten your password? <a style = "text-decoration: underline !important; font-weight: bold;" (click)="onResetPasswordPage()">Click Here</a>
        </div> -->
    </div>
    } @if (isTokenValid) {
    <div>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
        <div style="padding-bottom: 10px; display: flex; flex-direction: column">
          <mat-form-field style="width: 100%; max-height: 120px" [ngClass]="{ 'error-spacing': form.credential.touched && (form.credential.errors?.required || form.credential.errors?.pattern) }">
            <a style="font-weight: 500"> New Password: </a>
            <input
              class="input"
              matInput
              formControlName="credential"
              type="password"
              matTooltip="Password must have a minimum of 8 characters, 1 special character[ _!@#$%^&*() ], 1 upper case, 1 lower case and 1 number" />
            @if (form.credential.touched && (form.credential.errors?.required || form.credential.errors?.pattern)) {
            <mat-error> Password must have a minimum of 8 characters, 1 special character[ _!&#64;#$%^&*() ], 1 upper case, 1 lower case and 1 number </mat-error>
            }
          </mat-form-field>
          <mat-form-field style="width: 100%; max-height: 120px">
            <a style="font-weight: 500"> Re-enter Password: </a>
            <input class="input" matInput formControlName="confirmCredential" type="password" />
            @if (form.confirmCredential.touched && (form.confirmCredential.errors?.required || form.confirmCredential.hasError('passwordmatch'))) {
            <mat-error> Passwords don't match </mat-error>
            }
          </mat-form-field>
        </div>
        <div style="text-align: center">
          <button class="sendButton" mat-raised-button color="primary" id="btnSend" name="submit" [disabled]="passwordUpdated">
            @if (!isActivateAccount) {
            <span> Confirm </span>
            } @if (isActivateAccount) {
            <span> Activate </span>
            }
          </button>
        </div>
      </form>
    </div>
    } @if (passwordUpdated) {
    <div style="text-align: center; color: #6dbd4a; font-size: 12px">Password Updated Successfully</div>
    } @if (passwordUpdated) {
    <div style="text-align: center; text-decoration: underline; font-size: 14px">
      <a (click)="onBackToHomePage()">Login Now</a>
    </div>
    } @if (passwordUpdateFailed) {
    <div style="text-align: center; color: #c1272c; font-size: 12px">Error updating password, please refresh and try again or contact your admin.</div>
    }
  </form>
  }
</div>
